import { Component, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DataService, LoaderService, LocationService, UtilsService } from 'src/app/modules/shared/services';
import { BasicRegistrationService } from '../hospital-basic-registration/services/basic-registration.service';
import { IpdRegistrationService } from '../ipd-registration/services/ipd-registration.service';
import { PatientRegisterService } from '../patient-registration/services/patient-register.service';
import { RPPPatientMappingService } from '../rpp-patient-allocate/services/rpp-patient-mapping.service';
import { RppPatientService } from '../rpp-patient-list/services/rpp-patient.service';
import { SectionType } from '../consultation-review/section.enum';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-patient-dashboard',
  templateUrl: './patient-dashboard.component.html',
  styleUrls: ['./patient-dashboard.component.scss']
})
export class PatientDashboardComponent implements OnInit {
  data: any;
  data2: any;
  basicData: any;
  basic1Data: any;
  basic2Data: any;
  basic3Data: any;
  editData
  dashboardData: any
  dashboardPermission: any
  basicOptions: any;
  chartOptions: any;
  patientId
  enddate
  startDate = moment();
  sleepList = []
  graphData = []
  popupenable = false
  patientRegistration
  appetiteList = []
  mood_AffectList = []
  selfcare_GroomingList = []
  daily_routineList = []
  relationship_socialList = []
  medical_Compliancelist = []
  attention_concentrationList = []
  feedbackHistory = []
  showPsychiatristsfield = false
  disablePsychiatristvalue = true
  disableFeedbackvalue = true
  disableActivityvalue = true
  disbalePyshoDigno = true
  disablePsychologistvalue = true
  disablefield = false
  daily_activity_service: any;
  feedback_service: any;
  psychiatrist_consultation_count: any;
  Psychologist_Service_Monthly: any;
  Psychiatrist_Service_Monthly: any;
  asentReschedule: any;
  startdate = moment().format("dddd, MMMM Do YYYY, h:mm:ss a")
  currentdate = moment().format('YYYY-MM-DD')
  isPatientCRT: boolean = false;
  displayCrtDialog: boolean = false;
  crtAmount: number = null;
  showCrt: boolean = false;
  showWaerableDialog: boolean = false;
  showWearableDataButton: boolean = false;
  showActivityGraph: boolean = false;
  showFeedbackGraph: boolean = false;
  showPsychotherapyGraph: boolean = false;
  showPharmacotherapyGraph: boolean = false;
  selectedButton: number = 0;
  selectButton: number = 0;
  selectBtn: number = 0;
  sBtn: number = 0;
  activeIndex: number = 0;
  prospectToBuyWearable: boolean = false;
  commentedData: any;
  isComment: boolean = false;
  selectedCommentedData: any;
  dialogVisible: boolean = false; 
  iframeUrl!: SafeResourceUrl;
  isIframeLoading: boolean = true;
  onlineAssessmentForm: FormGroup;
  onlineAssessmentsList: any[] = [];
  assessmentPaymentAmount: number = 0;

  constructor(
    private route: Router,
    private basicRegService: BasicRegistrationService,
    private util: UtilsService,
    private patientRegisterService: PatientRegisterService,
    private activeRoute: ActivatedRoute,
    private locationsService: LocationService,
    private ipdRegService: IpdRegistrationService,
    private rppPatientMappingService: RPPPatientMappingService,
    public dataService: DataService,
    private messageService: MessageService,
    private rppPatientService: RppPatientService,
    private utilService: UtilsService,
    private loaderService: LoaderService,
    private sanitizer: DomSanitizer,
    private _fb: FormBuilder
  ) {
    const navigation = this.route.getCurrentNavigation();
    const state = navigation.extras.state;
    if (!state) {
      this.route.navigate(['/rpp-patient-list']);
      return;
    }
    this.editData = JSON.parse(state.editData);

  }
  openfeedback() {
    this.route.navigate([`/patient-dashboard/form/${this.editData.patient_id}/add-daily-feedback`])
  }

  openPyschoDiagnosticForm() {

    this.route.navigate([`/patientregistration/edit-patient/${this.editData.patient_id}`])
  }

  openActivity() {
    this.route.navigate([`/patient-dashboard/form/${this.editData.patient_id}/add-activity-feedback`])
  }

  openPsychiatrist() {
    this.route.navigate([`/patient-dashboard/form/${this.editData.patient_id}/add-session-psychiatrist`])
  }

  openPsychologist() {
    this.route.navigate([`/patient-dashboard/form/${this.editData.patient_id}/add-session-psychologist`])
  }

  openPatientRecord(data: any) {

    this.patientRegisterService.caseHistoryPayload(this.editData)

    let payload = {
      consultation_id: data.consultation_id
    }
    this.patientRegisterService.getPatientHistory(payload).subscribe(res => {

      this.patientRegisterService.setpatientHistory(res)

    })

    if (data.consultation_id) {
      this.route.navigate([`/patient-dashboard/form/${this.editData.patient_id}/view-patient-record`])
    } else {
      this.util.showErrorToast('Case history pending ');
    }

    // this.rppPatientMappingService.setConsultationId(this.dashboardData.consultation_id)
  }

  onTabChange(event: any) {
    this.activeIndex = event.index;  
  }

  async getPatientDashboardDetails() {
    this.patientId = this.activeRoute.snapshot.params.id;
    let payload = {
      patient_id: this.editData.patient_id
    }

    this.rppPatientMappingService.getPatientDashboardDetails(payload).subscribe((res: any) => {
      this.dashboardData = {
        ...res,
        patient_id: this.patientId
      }
      // this.rppPatientMappingService.setConsultationId(this.dashboardData.consultation_id)
      if (!this.dashboardData.consultation_id) {

      }

      if (this.dashboardData?.need_crt === 'yes' || this.dashboardData?.need_crt === 'Yes') {
        this.isPatientCRT = true;
      }

      this.getDashboardServicePermission();

      if (res.wearable_present) {
        this.showWearableDataButton = true;
      }

      this.viewAssessments();

    })

    this.asentReschedule = this.dashboardData?.absent_reschedule_data?.length

    this.psychiatrist_consultation_count = this.dashboardData?.psychiatrist_consultation_count ? this.dashboardData.psychiatrist_consultation_count : 0


    let dashboard_due_date: any = moment(this.dashboardData?.due_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
    let TodayDate = moment()
    let formatedTodayDate = moment(TodayDate).format('DD-MM-YYYY')


    if (moment(formatedTodayDate, 'DD-MM-YYYY').isAfter(moment(dashboard_due_date, 'DD-MM-YYYY'))) {
      this.disablefield = true
    }
    if (this.dataService.userDetails.name == 'Hospital Administrator') {
      this.disablefield = false
      this.disablePsychiatristvalue = false
      this.disablePsychologistvalue = false
      this.disableFeedbackvalue = false
      this.disableActivityvalue = false
      this.disbalePyshoDigno = false
    }

  }
  getDashboardServicePermission() {
    let rppDate = moment().format('YYYY-MM-DD')

    let payload = {
      patient_id: this.editData.patient_id,
      package_id: this.dashboardData?.package_id,
      rpp_date: rppDate
    }
    this.rppPatientMappingService.getDashboardServicePermission(payload).subscribe((res) => {
      let name1 = "Psychological Supervision"
      let name2 = "Psychiatrist Consultation"
      let name3 = "Psychologist Consultation"
      let name4 = "Daily Activities"
      let name5 = "Psychodiagnostic"
      this.dashboardPermission = res;
      this.dashboardPermission.forEach((ele) => {
        // if(ele.service_name.includes(name1) && ele.slot_status== "Assigned"){
        //   this.disableFeedbackvalue= false
        // }
        // if(ele.service_name.includes(name2) && ele.slot_status== "Assigned"){
        //   this.disablePsychiatristvalue= false
        // }
        // if(ele.service_name.includes(name3) && ele.slot_status== "Assigned"){
        //   this.disablePsychologistvalue= false
        // }
        // if(ele.service_name.includes(name4) && ele.slot_status== "Assigned"){
        //   this.disableActivityvalue= false
        // }
        // if(ele.service_name.includes(name1) && ele.slot_available== true){
        //   this.disablePsychiatristvalue= false
        // }
        // if(ele.service_name.includes(name2) && ele.slot_available== true){
        //   this.disablePsychologistvalue= false
        // }
        // if(ele.service_name.includes(name3) && ele.slot_available== true){
        //   this.disableFeedbackvalue= false
        // }
        // if(ele.service_name.includes(name4) && ele.slot_available== true){
        //   this.disableActivityvalue= false
        // }
        if (ele.service_name.includes(name5) && ele.slot_status == "Assigned") {
          this.disbalePyshoDigno = false
        }
      })

    })
  }
  async ngOnInit() {

    if (this.dataService.userDetails.name == 'Psychologist' || this.dataService.userDetails.name == 'Psychiatrist' || this.dataService.userDetails.name == 'Hospital Administrator') {
      this.showPsychiatristsfield = true

    }


    if (this.dataService.userDetails.name == "Counsellor") {
      this.showCrt = true;
      this.onlineAssessmentFormInit();
      this.getAllAssessments();
    }



    await this.getPatientDashboardDetails()
    //this.getDashboardServicePermission()
    this.getGraphFeedbackData()
    this.getGraphActivityData()
    this.getGraphPharmacotherapyData()
    this.getGraphPsycotherapyData()
    this.data = {
      labels: ['Pending', 'Balance', 'Complete'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            "#ff3f3f",

            "#FFA726",
            "#66BB6A"
          ],
          hoverBackgroundColor: [
            "#fb5050",

            "#FFB74D",
            "#81C784"
          ]
        }
      ]
    };



    this.data2 = {
      labels: ['Absent', 'Present', 'Complete'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            "#ff3f3f",

            "#FFA726",
            "#66BB6A"
          ],
          hoverBackgroundColor: [
            "#fb5050",

            "#FFB74D",
            "#81C784"
          ]
        }
      ]
    };
    this.getPatientOfflineAssessmentReport();
    this.getCaseReviewComment();
  }

  onlineAssessmentFormInit() {
    this.onlineAssessmentForm = this._fb.group({
      assessment_id: ['', Validators.required],
      paymentStatus: ['', Validators.required]
    });

    this.onlineAssessmentForm.get('assessment_id')?.valueChanges.subscribe(value => {
      const selectedAssessment = this.onlineAssessmentsList.find(
        assessment => assessment.value == value
      );

      if (selectedAssessment) {
        this.assessmentPaymentAmount = selectedAssessment.price;
      } else {
        this.assessmentPaymentAmount = 0;
      }
    });
  }

    getCaseReviewComment() {
      const payload = {
        patientId: this.patientId,
      }
  
      this.loaderService.isLoading.next(true);
      this.patientRegisterService.getCaseReviewComment(payload).subscribe({
        next: (res: any) => {
          this.loaderService.isLoading.next(false);
          this.commentedData = res?.data.filter((res: any) => res?.status === 'PENDING');
        },
        error: err => {
          this.loaderService.isLoading.next(false);
          this.utilService.showErrorToast('Error while fetching data')
        }
      })
    }
  
    onCommentView(event: any) {
      this.isComment = true;
      this.selectedCommentedData = event; 
    }

  getGraphFeedbackData() {
    this.selectBtn = 1
    let labelvalue = []
    let datasetValue = []
    let selfcare = []
    let dailyroutine = []
    let relationlist = []
    let attentionlist = []
    let medicallist = []
    let key
    let insidekey
    this.enddate = moment().subtract(15, 'days')
    let payload = {
      patient_id: this.editData.patient_id,
      start_feedback_date: this.enddate.format('YYYY-MM-DD'),
      end_feedback_date: this.startDate.format('YYYY-MM-DD')
    }
    this.patientRegisterService.getFeedbackGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res
      let count: number = 0;
      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          selfcare.push(ele[datasetValue[1]])
          dailyroutine.push(ele[datasetValue[2]])
          relationlist.push(ele[datasetValue[3]])
          attentionlist.push(ele[datasetValue[4]])
          medicallist.push(ele[datasetValue[5]])
          if (ele[datasetValue[1]] == 0 && ele[datasetValue[2]] == 0 && ele[datasetValue[3]] == 0 && ele[datasetValue[4]] == 0 && ele[datasetValue[5]] == 0) {
            this.showFeedbackGraph = false;
          } else {
            count++
          }
        })
      }

      if (count > 0) {
        this.showFeedbackGraph = true;
      }

      this.basicData = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: selfcare,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: dailyroutine,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: relationlist,
            fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: attentionlist,
            fill: false,
            backgroundColor: '#40E0D0',
            tension: .4
          },
          {
            label: datasetValue[5],
            data: medicallist,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          }
        ]
      };
    })

  }

  /**
   *Feedback Graph data
    Daily, weekly and monthly
   * @param flag 1,2
   */
  showFeedbackMonthlWeekGraph(flag: number) {
    this.selectBtn = 2;
    if (flag == 2)
      this.selectBtn = 3;
    let labelvalue = []
    let datasetValue = []
    let selfcare = []
    let dailyroutine = []
    let relationlist = []
    let attentionlist = []
    let medicallist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;

    let payload = {
      patient_id: this.patientId,
      duration_type: flag
    }
    this.patientRegisterService.getFeedbackGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res
      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          selfcare.push(ele[datasetValue[1]])
          dailyroutine.push(ele[datasetValue[2]])
          relationlist.push(ele[datasetValue[3]])
          attentionlist.push(ele[datasetValue[4]])
          medicallist.push(ele[datasetValue[5]])

        })
      }


      this.basicData = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: selfcare,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: dailyroutine,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: relationlist,
            fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: attentionlist,
            fill: false,
            backgroundColor: '#40E0D0',
            tension: .4
          },
          {
            label: datasetValue[5],
            data: medicallist,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          }
        ]
      };
    })

  }

  /**
 *Psycotherapy Graph data
  Daily, weekly and monthly
 * @param flag 1,2
 */
  showmonthlyweekPsycotherapygraph(flag: number) {
    this.selectButton = 2;
    if (flag == 2)
      this.selectButton = 3;
    let labelvalue = []
    let datasetValue = []
    let selfcare = []
    let dailyroutine = []
    let relationlist = []
    let attentionlist = []
    let medicallist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;

    let payload = {
      role_name: 'Psychologist',
      patient_id: this.patientId,
      duration_type: flag
    }
    this.patientRegisterService.getSessionGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res

      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          selfcare.push(ele[datasetValue[1]])
          dailyroutine.push(ele[datasetValue[2]])
          relationlist.push(ele[datasetValue[3]])
          attentionlist.push(ele[datasetValue[4]])
          medicallist.push(ele[datasetValue[5]])
        })
      }

      this.basic3Data = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: selfcare,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: dailyroutine,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: relationlist,
            fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: attentionlist,
            fill: false,
            backgroundColor: '#40E0D0',
            tension: .4
          },
          {
            label: datasetValue[5],
            data: medicallist,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          }
        ]
      };
    })

  }

  showmonthlyweekPharmacotherapygraph(flag: number) {
    this.selectedButton = 2
    if (flag == 2)
      this.selectedButton = 3

    let labelvalue = []
    let datasetValue = []
    let selfcare = []
    let dailyroutine = []
    let relationlist = []
    let attentionlist = []
    let medicallist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;

    let payload = {
      role_name: 'Psychiatrist',
      patient_id: this.patientId,
      duration_type: flag
    }
    this.patientRegisterService.getSessionGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res

      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          selfcare.push(ele[datasetValue[1]])
          dailyroutine.push(ele[datasetValue[2]])
          relationlist.push(ele[datasetValue[3]])
          attentionlist.push(ele[datasetValue[4]])
        })
      }

      this.basic2Data = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: selfcare,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: dailyroutine,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: relationlist,
            fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: attentionlist,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          },

        ]
      };
    })

  }

  getGraphActivityData() {
    this.sBtn = 1;
    let labelvalue = []
    let datasetValue = []
    let participation = []
    let understanding = []
    let concentration = []
    let response = []
    let interactive = []
    let cooperationlist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;
    this.enddate = moment().subtract(15, 'days')
    let payload = {
      patient_id: this.patientId,
      start_activity_date: this.enddate.format('YYYY-MM-DD'),
      end_activity_date: this.startDate.format('YYYY-MM-DD')
    }
    this.patientRegisterService.getActivityGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res
      let count: number = 0
      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          participation.push(ele[datasetValue[1]])
          understanding.push(ele[datasetValue[2]])
          response.push(ele[datasetValue[3]])
          concentration.push(ele[datasetValue[4]])
          interactive.push(ele[datasetValue[5]])
          cooperationlist.push(ele[datasetValue[6]])
          if (ele[datasetValue[1]] == 0 && ele[datasetValue[2]] == 0 && ele[datasetValue[3]] == 0 && ele[datasetValue[4]] == 0 && ele[datasetValue[5]] == 0 && ele[datasetValue[6]] == 0) {
            this.showActivityGraph = false;
          } else {
            count++
          }
        })
      }

      if (count > 0) {
        this.showActivityGraph = true;
      }


      this.basic1Data = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: participation,
            // fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: understanding,
            //fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: response,
            // fill: false,
            backgroundColor: '#40E0D0',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: concentration,
            // fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[5],
            data: interactive,
            //fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          },
          {
            label: datasetValue[6],
            data: cooperationlist,
            // fill: false,
            backgroundColor: '#0000FF',
            tension: .4
          }
        ]
      };
    })

  }

  /**
   *Activity Graph data
    Daily, weekly and monthly
   * @param flag 1=Weekly; 2=Monthly
   */
  showActivityMonthWeekgraph(flag) {
    this.sBtn = 2;
    if (flag == 2)
      this.sBtn = 3;
    let labelvalue = []
    let datasetValue = []
    let participation = []
    let understanding = []
    let concentration = []
    let response = []
    let interactive = []
    let cooperationlist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;
    let payload = {
      patient_id: this.patientId,
      duration_type: flag
    }
    this.patientRegisterService.getActivityGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res

      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          participation.push(ele[datasetValue[1]])
          understanding.push(ele[datasetValue[2]])
          response.push(ele[datasetValue[3]])
          concentration.push(ele[datasetValue[4]])
          interactive.push(ele[datasetValue[5]])
          cooperationlist.push(ele[datasetValue[6]])
        })
      }

      this.basic1Data = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: participation,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: understanding,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: response,
            fill: false,
            backgroundColor: '#495057',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: concentration,
            fill: false,
            backgroundColor: '40E0D0',
            tension: .4
          },
          {
            label: datasetValue[5],
            data: interactive,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          },
          {
            label: datasetValue[6],
            data: cooperationlist,
            fill: false,
            backgroundColor: '#0000FF',
            tension: .4
          }
        ]
      };
    })

  }

  /**
   * Pharmacotherapy Graph data
    Daily, weekly and monthly
   * @param flag 1=Weekly; 2=Monthly
   */
  getGraphPharmacotherapyData() {
    this.selectedButton = 1;
    let labelvalue = []
    let datasetValue = []
    let selfcare = []
    let dailyroutine = []
    let relationlist = []
    let attentionlist = []
    let medicallist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;
    this.enddate = moment().subtract(15, 'days')
    let payload = {
      role_name: 'Psychiatrist',
      patient_id: this.patientId,
      start_session_date: this.enddate.format('YYYY-MM-DD'),
      end_session_date: this.startDate.format('YYYY-MM-DD')
    }
    this.patientRegisterService.getSessionGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res
      let count: number = 0
      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          selfcare.push(ele[datasetValue[1]])
          dailyroutine.push(ele[datasetValue[2]])
          relationlist.push(ele[datasetValue[3]])
          attentionlist.push(ele[datasetValue[4]])
          if (ele[datasetValue[1]] == 0 && ele[datasetValue[2]] == 0 && ele[datasetValue[3]] == 0 && ele[datasetValue[4]] == 0) {
            this.showPharmacotherapyGraph = false;
          } else {
            count++
          }
        })
      }


      if (count > 0) {
        this.showPharmacotherapyGraph = true;
      }


      this.basic2Data = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: selfcare,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: dailyroutine,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: relationlist,
            fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: attentionlist,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          },

        ]
      };
    })

  }

  getGraphPsycotherapyData() {
    this.selectButton = 1;
    let labelvalue = []
    let datasetValue = []
    let selfcare = []
    let dailyroutine = []
    let relationlist = []
    let attentionlist = []
    let medicallist = []
    let key
    let insidekey
    this.patientId = this.activeRoute.snapshot.params.id;
    this.enddate = moment().subtract(15, 'days')
    let payload = {
      role_name: 'Psychologist',
      patient_id: this.patientId,
      start_session_date: this.enddate.format('YYYY-MM-DD'),
      end_session_date: this.startDate.format('YYYY-MM-DD')
    }
    this.patientRegisterService.getSessionGraphHistory(payload).subscribe((res: any) => {
      this.graphData = res
      let count: number = 0
      for (key of Object.keys(res)) {
        labelvalue.push(key)
        let graphvalue = []
        graphvalue = res[key]
        graphvalue.forEach((ele) => {
          for (insidekey of Object.keys(ele)) {
            datasetValue.push(insidekey)
          }
          selfcare.push(ele[datasetValue[1]])
          dailyroutine.push(ele[datasetValue[2]])
          relationlist.push(ele[datasetValue[3]])
          attentionlist.push(ele[datasetValue[4]])
          medicallist.push(ele[datasetValue[5]])
          if (ele[datasetValue[1]] == 0 && ele[datasetValue[2]] == 0 && ele[datasetValue[3]] == 0 && ele[datasetValue[4]] == 0 && ele[datasetValue[5]] == 0) {
            this.showPsychotherapyGraph = false;
          } else {
            count++
          }
        })
      }

      if (count > 0) {
        this.showPsychotherapyGraph = true;
      }

      this.basic3Data = {
        labels: labelvalue,
        datasets: [
          {
            label: datasetValue[1],
            data: selfcare,
            fill: false,
            backgroundColor: '#42A5F5',
            tension: .4
          },
          {
            label: datasetValue[2],
            data: dailyroutine,
            fill: false,
            backgroundColor: '#FFA726',
            tension: .4
          },
          {
            label: datasetValue[3],
            data: relationlist,
            fill: false,
            backgroundColor: '#f44336',
            tension: .4
          },
          {
            label: datasetValue[4],
            data: attentionlist,
            fill: false,
            backgroundColor: '#40E0D0',
            tension: .4
          },
          {
            label: datasetValue[5],
            data: medicallist,
            fill: false,
            backgroundColor: '#66BB6A',
            tension: .4
          }
        ]
      };
    })

  }

  crtToggleChange() {
    this.displayCrtDialog = true;
  }

  cancelCRT() {
    this.displayCrtDialog = false;
    this.isPatientCRT = false;
  }

  saveCRT() {
    const dueDate = moment(this.dashboardData?.due_date, "DD-MM-YYYY");
    const currentDate = moment();
    // Calculate days remaining from the current date
    const daysRemaining = dueDate.diff(currentDate, 'days');
    // Multiply daysRemaining by 2
    const frequency = daysRemaining * 2;

    const payload = {
      patient_rpp_id: this.dashboardData?.patient_rpp_id,
      frequency,
      crt_price: this.crtAmount
    }
    this.ipdRegService.addCRT(payload).subscribe(
      (res: any) => {
        if (res?.patientRppRegistrationDetail?.need_crt === 'yes' || res?.patientRppRegistrationDetail?.need_crt === 'Yes') {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CRT added successfully' });
          this.displayCrtDialog = false;
          this.isPatientCRT = true;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'CRT not added' });
        }
      }
    )
  }

  getPackageList() {
    this.ipdRegService.getPackagelist().subscribe((res: any) => {
      const crtPackage = res.find(item => item.package_name === "Group Crt Service");
      this.crtAmount = crtPackage.package_price;
    })
  }

  toggleWearableDialog() {
    this.showWaerableDialog = true;
  }

  setWearableConnected(event) {
    //this.showWaerableDialog = false;
    //this.showWearableDataButton = true;
  }

  navigateToWearable() {

    localStorage.setItem('dashboardData', JSON.stringify(this.dashboardData));
    this.route.navigate([`/wearables/${this.editData.patient_id}`])
  }

  isWearableCommentForm: boolean = false;
  newComment: string = '';
  toggleWearableCommentForm() {
    this.isWearableCommentForm = !this.isWearableCommentForm;
    if (this.isWearableCommentForm) {
      this.getAllPatientWearableComments();
    }
  }

  saveComment() {
    if (this.newComment) {
      const payload = {
        patient_id: this.editData.patient_id,
        remarks: this.newComment,
        wearable_device_from_emoneeds: this.prospectToBuyWearable
      }
      this.patientRegisterService.saveWearableComments(payload).subscribe((res: any) => {
        this.newComment = '';
        this.getAllPatientWearableComments();
      })
    }
  }

  patientRemarkData: any = [];
  getAllPatientWearableComments() {
    const payload = {
      patientId: this.editData.patient_id
    }
    this.patientRegisterService.getAllPatientWearableComments(payload).subscribe((res: any) => {
      this.patientRemarkData = res.data;
    })
  }

  displayEditCommentDialog: boolean = false;
  editCommentText: string = '';
  editCommentId: string = '';
  editComment(remark) {
    this.editCommentText = remark.remark;
    this.editCommentId = remark.wearable_remark_id;
    this.displayEditCommentDialog = true;
  }

  saveEditedComment() {
    const payload = {
      remarkId: this.editCommentId,
      remarks: this.editCommentText
    }
    this.patientRegisterService.updateWearableComment(payload).subscribe((res: any) => {
      this.displayEditCommentDialog = false;
      this.editCommentText = '';
      this.editCommentId = '';
      this.getAllPatientWearableComments();
    })
  }

  deleteCommentId: string = '';
  deleteCommentDialog: boolean = false;
  deleteCommentText = '';
  deleteComment(remark) {
    this.deleteCommentDialog = true;
    this.deleteCommentId = remark.wearable_remark_id;
    this.deleteCommentText = remark.remark;
  }

  deleteCommentConfirm() {
    const payload = {
      remarkId: this.deleteCommentId
    }
    this.patientRegisterService.deleteWearableComment(payload).subscribe((res: any) => {
      this.deleteCommentDialog = false;
      this.deleteCommentId = '';
      this.deleteCommentText = '';
      this.getAllPatientWearableComments();
    })
  }

  deleteCommentCancel() {
    this.deleteCommentDialog = false;
    this.deleteCommentId = '';
    this.deleteCommentText = '';
  }

  assessmentData: any = [];
  offlineAssessmentData: any = []
  isAssessmentData: boolean = false;

  viewAssessments() {

    this.rppPatientService.getPatientAssessments(this.dashboardData.assesment_user_id).subscribe((res: any) => {
      this.assessmentData = res.data.result;
    })
  }

  getPatientOfflineAssessmentReport() {
    const payload = {
      assigned_to: this.dataService?.userDetails?.user_id,
      hosp_id: this.dataService?.userDetails?.hosp_id,
      patient_id: this.editData.patient_id,
      isPagination: false
    }
    this.rppPatientService.getPatientOfflineAssessment(payload).subscribe(
      (res: any) => {
        this.offlineAssessmentData = res?.data?.offlineAssessments ?? [];
      },
      err => {
      }
    );
  }


  downloadOfflineAssessmentPortal(data) {
    const payload = {
      assessment_report_id: data.assessment_report_id
    }
    this.rppPatientService.getPatientOfflineAssessmentReport(payload).subscribe(
      (response: Blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = `assessment-report-${data.assessment_shortname}-${this.dashboardData?.patient_name}-${data.assessment_report_id}.pdf`
        a.click();
        URL.revokeObjectURL(objectUrl);
      },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Report not downloaded' });
      }
      );
  }

  copyAssessmentLink(){
    this.utilService.showSuccessToast('Assessment Link Copied Successfully'); 
  }

  viewAssessmentScore(assessmentData: any) {
    const payload = {
      email: assessmentData.email_id,
      assessment_id: assessmentData.assessment_id,
      user_id: assessmentData.user_id,
      assessment_transaction_id: assessmentData.assessment_transaction_id,
      practitioner_id: 111111,
    };
    const rawUrl = `${environment.ASSESSMENT_DOMAIN_URL}result/admin/${payload.email}-${payload.assessment_id}-${payload.user_id}-${payload.practitioner_id}-${payload.assessment_transaction_id}`;
    // this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
    // this.dialogVisible = true; 
    // this.isIframeLoading = true;
    window.open(rawUrl, '_blank');
  }

  getAllAssessments() {
    this.patientRegisterService.getAllAssessments().subscribe((res: any) => {
      if(res.data && res.data.length) {
        const assignedAssessments = res.data;
        this.onlineAssessmentsList =  
          assignedAssessments.map((item): any => 
            ({ 
              label: `${item.shortName} - ${item.assessmentName}`, 
              value: item.assessment_id, 
              shortName: item.shortName,
              price: item.price  
            }));
      }
    });
  }

  initiateAssessment() {

    if(this.onlineAssessmentForm.invalid) {
      this.onlineAssessmentForm.markAllAsTouched();
      this.utilService.showInfoToast('Please fill all required fields');
      return;
    }

    const assessmentPayload = {
      email_id: [this.dashboardData.email_id],
      assessment_id: [this.onlineAssessmentForm.value.assessment_id],
      practitioner_id: 111111,
      practioner_role: this.dataService.userDetails.name,
      schedule_start_setting_enabled: false,
      schedule_start_date: moment().format('YYYY-MM-DD'),
      schedule_start_time: "00:00",
      repeat_setting_enabled: false,
      email_assessment_to_client: true,
      send_assessment_report_to_client: true,
      frequency: 1,
      duration: 1,
      referred_by_enabled: false,
      referred_by: '',
      isAdmin: true,
      patient_ref_id: this.dashboardData.patient_ref_id,
      status: this.onlineAssessmentForm.value.paymentStatus,
      amount: this.assessmentPaymentAmount
    };

    this.patientRegisterService.initiateAssessment(assessmentPayload).subscribe({
      next: (res: any) => {
          if (res.success) {
          this.utilService.showSuccessToast('Assessment initiated successfully');
          this.assessmentPaymentAmount = 0;
          this.onlineAssessmentForm.reset();
          this.viewAssessments();
        } else {
          this.utilService.showErrorToast('Failed to initiate assessment');
        }
      },
      error: err => { 
        this.utilService.showErrorToast('Error while initiating assessment');
      }
    })
  }

}
